import { useMemo } from 'react';
import useWindowWidth from './useWindowWidth';
import PRODUCT_CARD_CONSTANTS, { getFinalOrientation } from '../constants/productCardConstants';
import { mapProductCardConfigToFormatting } from '../product/productCardConfig';
const useProductCardResponsive = ({ clientAIConfig, conversation, message, }) => {
    const windowWidth = useWindowWidth();
    // Get config from different possible sources
    const resolvedClientAIConfig = useMemo(() => clientAIConfig
        || conversation?.clientAIConfig
        || message?.conversation?.clientAIConfig, [clientAIConfig, conversation, message]);
    const rawConfig = resolvedClientAIConfig?.productCardConfig;
    const adminFormatting = rawConfig
        ? mapProductCardConfigToFormatting(rawConfig)
        : undefined;
    const userOrientation = (adminFormatting?.orientation || 'vertical');
    // Get configured widths with fallbacks
    const horizontalWidth = adminFormatting?.horizontalWidth
        ?? PRODUCT_CARD_CONSTANTS.DEFAULT_HORIZONTAL_WIDTH;
    const verticalWidth = adminFormatting?.verticalWidth
        ?? PRODUCT_CARD_CONSTANTS.DEFAULT_VERTICAL_WIDTH;
    // Calculate breakpoints from configured widths
    const resetCssHorizontal = horizontalWidth + (2 * PRODUCT_CARD_CONSTANTS.BREAKPOINT_OFFSET);
    const forceVerticalBreakpoint = horizontalWidth + PRODUCT_CARD_CONSTANTS.BREAKPOINT_OFFSET;
    const resetCssVertical = verticalWidth + PRODUCT_CARD_CONSTANTS.BREAKPOINT_OFFSET;
    // Determine final orientation
    const finalOrientation = getFinalOrientation(windowWidth, userOrientation, horizontalWidth);
    const isHorizontal = finalOrientation === 'horizontal';
    const isTinyScreen = windowWidth < resetCssVertical;
    // Apply responsive styles based on table logic
    const shouldApplyResponsiveStyles = (
    // Case 1: User chose horizontal but screen is in intermediate range (445px - 469px)
    (userOrientation === 'horizontal' && windowWidth < resetCssHorizontal && windowWidth >= forceVerticalBreakpoint)
        // Case 2: Screen is too narrow for vertical (< 145px)
        || isTinyScreen);
    // Debug logging
    // console.log('[useProductCardResponsive]', {
    //   windowWidth,
    //   userOrientation,
    //   horizontalWidth,
    //   verticalWidth,
    //   resetCssHorizontal,
    //   forceVerticalBreakpoint,
    //   resetCssVertical,
    //   shouldApplyResponsiveStyles,
    //   isTinyScreen,
    //   finalOrientation,
    // });
    // Convert numeric widths to px strings
    const cardWidth = isHorizontal ? `${horizontalWidth}px` : `${verticalWidth}px`;
    // Calculate forceVertical: true when finalOrientation is vertical but user wanted horizontal
    // This happens when screen is too narrow for horizontal cards
    const forceVertical = userOrientation === 'horizontal' && finalOrientation === 'vertical';
    return {
        windowWidth,
        userOrientation,
        finalOrientation,
        isHorizontal,
        shouldApplyResponsiveStyles,
        isTinyScreen,
        cardWidth,
        forceVertical,
    };
};
export default useProductCardResponsive;
//# sourceMappingURL=useProductCardResponsive.js.map